import { InputField, InputSelectOptions, ToggleField } from 'components/molecules'
import { Form, Formik } from 'formik'
import {  Alert, Button, FormGroup, FormText, Input, Label, Badge, Card, CardBody } from 'reactstrap'
import {  NOTIFICATION_RECEIVERS } from 'domains/announcements/constants'
import PropTypes from 'prop-types'
import blastSchema from './blast-schema'
import DynamicContentFormSection from 'domains/announcements/components/dynamic-content-form-section'
import ReactDatePicker from 'react-datepicker'

const propTypes = {
  selectedTemplate                       : PropTypes.object,
  onSubmit                               : PropTypes.func,
  handleFetchSampleReceivers             : PropTypes.func,
  onChangeTinkerlustTitleDynamicContents : PropTypes.func,
  onChangeTinkerlustBodyDynamicContents  : PropTypes.func,
  onChangeWhatsappBodyDynamicContents    : PropTypes.func,
  onChangeWhatsappButtonDynamicContents  : PropTypes.func,
  csvColumns                             : PropTypes.array,
  scheduledDate                          : PropTypes.object,
  setScheduledDate                       : PropTypes.func
}

const defaultProps = {
  selectedTemplate: {
    name       : '',
    tinkerlust : {
      title   : '',
      message : ''
    },
    whatsapp: [ {
      message_body    : '',
      message_header  : '',
      message_buttons : ''
    } ]
  },
  onSubmit                               : () => { },
  handleFetchSampleReceivers             : () => { },
  onChangeTinkerlustTitleDynamicContents : () => {},
  onChangeTinkerlustBodyDynamicContents  : () => {},
  onChangeWhatsappBodyDynamicContents    : () => {},
  onChangeWhatsappButtonDynamicContents  : () => {},
  csvColumns                             : [],
  scheduledDate                          : {},
  setScheduledDate                       : () => { }
}


const BlastForm = ({
  selectedTemplate,
  onSubmit,
  handleFetchSampleReceivers,
  onChangeTinkerlustTitleDynamicContents,
  onChangeTinkerlustBodyDynamicContents,
  onChangeWhatsappBodyDynamicContents,
  onChangeWhatsappButtonDynamicContents,
  csvColumns,
  scheduledDate,
  setScheduledDate
}) => {
  // Set how many dynamic fields that we should set to Formik
  const getDynamicContentFields = (text) => {
    const regex = /\{{([^}]+)\}}/g
    // Detect dynamic content or word that wrapped by {{}}
    // e.g. {{1}}, {{2}}
    const foundWords = text?.match(regex)


    // if the template have dynamic content,
    // we will set dynamic content field based on how many dynamic content in the template
    if (foundWords) {
      const newDynamicInputFields = foundWords.map((word) => {
        // get number/content inside double curly bracket {{}}
        // e.g {{1}} => 1 , {{2}} => 2
        const contentNumber = word.replace(/[^a-zA-Z0-9 ]/g, '')
        return ({
          content_number : parseInt(contentNumber),
          resource       : '',
          attribute      : '',
          value          : '',
          formatting     : ''
        })
      })
      return newDynamicInputFields
    }

    // return empty array if template dont have dynamic content
    return []
  }

  const resetDynamicContentAfterChange = (event, setFieldValue, formikValues) => {
    const receiverValue = event.target.value
    setFieldValue('receiver', receiverValue)
    setFieldValue('dynamic_contents', getDynamicContentFields(selectedTemplate?.tinkerlust?.message))
    if (formikValues.csv) {
      handleFetchSampleReceivers(formikValues.csv, formikValues.id, receiverValue)
    }
  }

  const setCsvValue = (csv, setFieldValue, formikValues) => {
    setFieldValue('csv', csv)
    if (formikValues.receiver) {
      handleFetchSampleReceivers(csv, formikValues.id, formikValues.receiver)
    }
  }

  const TEMPLATE_LINK              = 'https://drive.google.com/file/d/1wk99TBikQ1NfAtt53tGUwLK-vrbk-HJn/view'
  const ALL_MOBILE_APPS_USERS_LINK = '/app/customer-service/mobile_apps_users'

  const tinkerlust_title = selectedTemplate?.tinkerlust?.title
  const tinkerlust_body  = selectedTemplate?.tinkerlust?.message
  const whatsapp_body    = selectedTemplate?.whatsapp?.message_body
  const whatsapp_buttons = selectedTemplate?.whatsapp?.message_bottons

  return (
    <Formik
      initialValues={{
        id                          : selectedTemplate?.id,
        channel                     : selectedTemplate?.channel,
        receiver                    : '',
        template_name               : selectedTemplate?.name,
        is_test                     : false,
        is_push_notification_url    : false,
        is_scheduled                : false,
        test_number                 : '',
        test_email                  : '',
        csv                         : '',
        tinkerlust_dynamic_contents : {
          title : tinkerlust_title ? getDynamicContentFields(tinkerlust_title) : [],
          body  : tinkerlust_body ? getDynamicContentFields(tinkerlust_body) : []
        },
        whatsapp_dynamic_contents: {
          body   : whatsapp_body ? getDynamicContentFields(whatsapp_body) : [],
          button : whatsapp_buttons ? getDynamicContentFields(whatsapp_buttons) : []
        }
      }}
      validationSchema={ blastSchema }
      enableReinitialize={ true }
      onSubmit={ onSubmit }
    >
      {
        (formikBag) => {
          const showDynamicContentSection = formikBag.values.receiver && formikBag.values.csv
          const showDynamicContentAlert   = showDynamicContentSection && formikBag.values.dynamic_contents.length > 0

          return (
            <Card>
              <CardBody>
                <Form>
                  <InputField
                    type='select'
                    name='receiver'
                    label='Receivers'
                    onChange={ (event) => resetDynamicContentAfterChange(event, formikBag.setFieldValue, formikBag.values) }
                    required={ true }
                    formText={ <>
                      <strong>{ 'User: ' }</strong>{ 'Memilih User sebagai receiver akan BISA dilakukan tracking oleh Team BI.' }
                      <br />
                      <strong>{ 'Customer/ Seller: ' }</strong>{ 'Untuk Customer atau Seller receiver, akan tetap bisa Blast, tetapi TIDAK bisa dilakukan tracking.' }
                      <br />
                      <strong>{ '*Tracking: ' }</strong>{ 'Melakukan track berapa banyak template di-read dan delivered kepada recipients Blast.' }
                    </> }
                  >
                    <InputSelectOptions
                      options={ NOTIFICATION_RECEIVERS }
                      keyPrefix={ 'receiver' }
                    />
                  </InputField>

                  <FormGroup>
                    <Alert color='info'>
                      <i className='fas fa-info-circle mr-3' />

                      { 'Batas maksimal baris(data) pada csv adalah ' }
                      <strong>
                        { '7000' }
                      </strong>
                    </Alert>
                    <Label
                      for={ 'csv' }
                      className='text-gray-light text-capitalize'
                    >
                      <strong>{ 'Upload CSV' }</strong>
                    </Label>
                    <Badge
                      color='warning'
                      className='ml-1'
                    >
                      <i className='fas fa-asterisk' />
                    </Badge>
                    <Input
                      type={ 'file' }
                      accept='.csv'
                      onChange={ (event) => setCsvValue(event.currentTarget.files[0], formikBag.setFieldValue, formikBag.values) }
                    />

                    { formikBag.errors.csv && (
                      <small className='mt-3 text-danger'>
                        { formikBag.errors.csv }
                      </small>
                    ) }
                    <FormText>
                      { 'Mohon Upload file csv dengan maksimal rows; ' }
                      <strong>{ '7000 rows' }</strong>
                      <br/>
                      { 'apabila terdapat data lebih dari 7000 rows, mohon lakukan blast secara bertahap.' }
                    </FormText>

                    <FormText>
                      { 'Mohon upload file csv dengan format sebagai ' }
                      <strong>
                        <a
                          href={ TEMPLATE_LINK }
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          { 'berikut' }
                        </a>
                      </strong>
                    </FormText>

                    <FormText>
                      { 'Untuk melihat referensi user yang eligible untuk push notification. Mohon melihat referensi page ' }
                      <strong>
                        <a
                          href={ ALL_MOBILE_APPS_USERS_LINK }
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          { 'berikut' }
                        </a>
                      </strong>
                    </FormText>
                  </FormGroup>

                  {
                    showDynamicContentAlert && (
                      <Alert color='info'>
                        <i className='fas fa-info-circle mr-3' />
                        <span>
                          { 'Mohon isi semua field untuk mengganti konten dinamis.' }
                          <br />
                          <strong>
                            { 'Contoh: {{1}}, {{2}}, {{3}} ,....' }
                          </strong>
                        </span>
                      </Alert>
                    )
                  }
                  {
                    // Text Dynamic Values
                    showDynamicContentSection && (
                      <>
                        <DynamicContentFormSection
                          inputTitle='Tinkerlust Title Contents'
                          dynamicContents={ formikBag.values.tinkerlust_dynamic_contents.title }
                          receiver={ formikBag.values.receiver }
                          setFieldValue={ formikBag.setFieldValue }
                          fieldName={ 'tinkerlust_dynamic_contents.title' }
                          onChangeDynamicContents={ onChangeTinkerlustTitleDynamicContents }
                          csvColumns={ csvColumns }
                        />
                        <DynamicContentFormSection
                          inputTitle='Tinkerlust Body Contents'
                          dynamicContents={ formikBag.values.tinkerlust_dynamic_contents.body }
                          receiver={ formikBag.values.receiver }
                          setFieldValue={ formikBag.setFieldValue }
                          fieldName={ 'tinkerlust_dynamic_contents.body' }
                          onChangeDynamicContents={ onChangeTinkerlustBodyDynamicContents }
                          csvColumns={ csvColumns }
                        />
                        <DynamicContentFormSection
                          inputTitle='Whatsapp Body Contents'
                          dynamicContents={ formikBag.values.whatsapp_dynamic_contents.body }
                          receiver={ formikBag.values.receiver }
                          setFieldValue={ formikBag.setFieldValue }
                          fieldName={ 'whatsapp_dynamic_contents.body' }
                          onChangeDynamicContents={ onChangeWhatsappBodyDynamicContents }
                          csvColumns={ csvColumns }
                        />
                        <DynamicContentFormSection
                          inputTitle='Whatsapp Buttons'
                          dynamicContents={ formikBag.values.whatsapp_dynamic_contents.button }
                          receiver={ formikBag.values.receiver }
                          setFieldValue={ formikBag.setFieldValue }
                          fieldName={ 'whatsapp_dynamic_contents.botton' }
                          onChangeDynamicContents={ onChangeWhatsappButtonDynamicContents }
                          csvColumns={ csvColumns }
                        />
                      </>
                    )
                  }

                  <ToggleField
                    id={ 'is_test' }
                    name={ 'is_test' }
                    label={ 'Test mode?' }
                    formText={ <>
                      <strong>{ 'Yes: ' }</strong>{ 'Mengaktifkan mode uji coba untuk melihat contoh pesan yang akan diterima user/seller/customer.' }
                      <br />
                      <strong>{ 'No: ' }</strong>{ 'Akan mengirimkan pesan kepada seluruh user/seller/customer.' }
                    </> }
                  />

                  {
                    formikBag.values.is_test && (
                      <>
                        {
                          <InputField
                            type='email'
                            name='test_email'
                            label='Test Email'
                            required={ true }
                          />
                        }
                      </>
                    )
                  }

                  { /* Disable Temporary Need Refactor backend first */ }
                  <ToggleField
                    id={ 'is_scheduled' }
                    name={ 'is_scheduled' }
                    label={ 'Scheduled mode?' }
                    formText={ <>
                      <strong>{ 'Yes: ' }</strong>{ 'Mengaktifkan mode schedule, blast akan dilakukan sesuai jadwal yang ditentukan.' }
                      <br />
                      <strong>{ 'No: ' }</strong>{ 'Akan mengirimkan blast notification sekarang juga.' }
                      <br />
                      <strong>{ 'Push Notif: ' }</strong>{ 'Mohon hanya gunakan 1 column "id" CSV, untuk Scheduling Blast Push Notification.' }
                      <br />
                      <strong>{ 'Whatsapp: ' }</strong>{ 'Mohon hanya isikan column-column yang diperlukan untuk dinamik konten di CSV, untuk Scheduling Blast Whatsapp.' }
                    </> }
                  />

                  {
                    formikBag.values.is_scheduled && (
                      <>
                        {
                          <ReactDatePicker
                            className='mb-3 mt-3'
                            selected={ scheduledDate }
                            onChange={ setScheduledDate }
                            timeInputLabel="Time:"
                            dateFormat="dd/MMMM/yyyy HH:mm"
                            timeFormat="HH:mm"
                            timeIntervals={ 1 }
                            showTimeSelect
                          />
                        }
                      </>
                    )
                  }

                  {
                    formikBag.values.is_scheduled ?
                      <Button
                        type='submit'
                        color='primary'
                        disabled={ formikBag.isSubmitting }
                      >
                        { 'Schedule Blast Notification' }
                      </Button>
                      :
                      <Button
                        type='submit'
                        color='primary'
                        disabled={ formikBag.isSubmitting }
                      >
                        { formikBag.values.is_test ? 'Send Test Notification' : 'Blast Notification' }
                      </Button>
                  }

                </Form>
              </CardBody>
            </Card>
          )
        }
      }
    </Formik>
  )
}

BlastForm.propTypes    = propTypes
BlastForm.defaultProps = defaultProps

export default BlastForm
